/**
 * Parse API error response
 * Handles standard API error format from CRUD_Operations_Standards.md
 */
export const parseApiError = (error) => {
  // If error is already in API format
  if (error && typeof error === 'object' && 'success' in error) {
    return {
      message: error.message || 'An error occurred',
      code: error.error?.code || 'UNKNOWN_ERROR',
      type: error.error?.type || 'Error',
      details: error.error?.details,
      fields: error.error?.fields || {},
    }
  }

  // If error is axios error
  if (error && error.response) {
    return {
      message: error.response.data?.message || error.message || 'Server error',
      code: error.response.status,
      type: error.response.statusText,
      details: error.response.data,
      fields: error.response.data?.error?.fields || {},
    }
  }

  // Generic error
  return {
    message: error?.message || 'An unexpected error occurred',
    code: 'UNKNOWN_ERROR',
    type: 'Error',
    details: error,
    fields: {},
  }
}

/**
 * Get user-friendly error message
 */
export const getErrorMessage = (error) => {
  const parsed = parseApiError(error)
  return parsed.message
}

/**
 * Get field-specific errors (for form validation)
 */
export const getFieldErrors = (error) => {
  const parsed = parseApiError(error)
  return parsed.fields || {}
}

/**
 * Check if error is a specific HTTP status code
 */
export const isErrorCode = (error, code) => {
  const parsed = parseApiError(error)
  return parsed.code === code
}

/**
 * Common error status codes
 */
export const ERROR_CODES = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  SERVER_ERROR: 500,
}

/**
 * Check if error is authentication error
 */
export const isAuthError = (error) => {
  return isErrorCode(error, ERROR_CODES.UNAUTHORIZED) ||
         isErrorCode(error, ERROR_CODES.FORBIDDEN)
}

/**
 * Check if error is validation error
 */
export const isValidationError = (error) => {
  return isErrorCode(error, ERROR_CODES.UNPROCESSABLE_ENTITY) ||
         isErrorCode(error, ERROR_CODES.BAD_REQUEST)
}
